import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  ElementRef,
  OnInit,
  Attribute
} from "@angular/core";
import { NgxPermissionsService } from "ngx-permissions";

@Directive({
  selector: "[ngxOrPermission]"
})
export class NgxOrPermissionDirective implements OnInit {
  private currentUserPermissions;
  private permissions = [];
  private logicalOp = "AND";
  private isHidden = true;

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionsService: NgxPermissionsService
  ) {}

  ngOnInit() {
    const permissions = this.permissionsService.getPermissions();
    this.permissionsService.permissions$.subscribe(perm => {
      this.currentUserPermissions = perm;
      this.updateView();
    });
  }

  @Input()
  set ngxOrPermission(val) {
    this.permissions = val;
    this.updateView();
  }

  private updateView() {
    if (this.checkPermission() && this.permissions.length) {
    if (this.isHidden) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    }
  }else if(!this.permissions.length){
    if (this.isHidden) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    }
  } else {
    this.isHidden = true;
    this.viewContainer.clear();
  }
}

  private checkPermission() {
    let hasPermission = false;
    if (
      this.currentUserPermissions &&
      Object.keys(this.currentUserPermissions).length
    ) {
      const permissionFound = Object.keys(this.currentUserPermissions).filter(
        userPermission => {
          return this.permissions.includes(userPermission);
        }
      );
      hasPermission = permissionFound.length ? true : false;
    }
    return hasPermission;
  }
}
